// definitions for each agent
import { DiagnosticAgentConfiguration } from "./configurationTypes";
import { DiagnosticAgentType } from "../../../context/diagnosticAgent";
import { COVID19_DD_PANEL } from "../../../util/covid19";

export const DiagnosticAgentConfigurations: Partial<Record<
  DiagnosticAgentType,
  DiagnosticAgentConfiguration
>> = {
  [DiagnosticAgentType.ER]: {
    title: "Emergency Medicine",
    dataEntryPanelID: "FE.f7a0ab47-cf90-414b-977c-06ca4be1b959",
    considerPanelIDs: ["FE.79354786-3f56-4962-98b4-a6b6c55b6ba2"],
  },
  [DiagnosticAgentType.FamilyMedicine]: {
    title: "Family Medicine",
    dataEntryPanelID: "FE.ffeb38c3-bd34-4aca-9333-fb52f5e82d01",
    considerPanelIDs: ["FE.f2fcc92a-a825-484a-82af-a2f83c1d014e"],
  },
  [DiagnosticAgentType.FirstAid]: {
    title: "First Aid",
    dataEntryPanelID: "FE.9c5839a8-b936-403e-8b1d-8275363736b4",
    considerPanelIDs: ["FE.9dcaa257-19b6-40d8-86c7-65205e8f77d6"],
  },
  [DiagnosticAgentType.Covid]: {
    title: "Covid-19",
    dataEntryPanelID: "FE.efe29a33-0208-4c45-aa01-cc113e327e3f",
    considerPanelIDs: [COVID19_DD_PANEL],
  },
  [DiagnosticAgentType.InternalMedicine]: {
    title: "Internal Medicine",
    dataEntryPanelID: "FE.d770b731-33a5-48be-b7d2-b2c71318571a",
    considerPanelIDs: ["FE.d7bc7c49-67d5-4a3c-bffa-0fb9fdeb7daa"],
  },
  [DiagnosticAgentType.Test]: {
    title: "Test",
    dataEntryPanelID: "FE.d770b731-33a5-48be-b7d2-b2c71318571a",
    considerPanelIDs: [COVID19_DD_PANEL],
  },
};
